import {CompanyID} from '@/types/company';
import {Grid, Paper, SxProps, Typography, useTheme} from '@mui/material';
import Linkify from 'linkify-react';

interface CompanyInfosProps {
  companyData: CompanyID;
  sx?: SxProps;
}

const CompanyInfos: React.FC<CompanyInfosProps> = ({companyData, sx}) => {
  const theme = useTheme();
  return (
    <>
      <Paper elevation={3} sx={{p: 3}}>
        <Grid container spacing={3} sx={sx}>
          {/* <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              {companyData.title}
            </Typography>
          </Grid> */}

          {companyData.welcome && (
            <Grid item xs={12}>
              <Typography variant="body1" gutterBottom>
                <Linkify
                  options={{
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    attributes: {
                      style: {
                        color: theme.palette.customColors?.urlLink
                      }
                    }
                  }}
                >
                  {companyData.welcome}
                </Linkify>
              </Typography>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default CompanyInfos;
